import 'bootstrap/dist/css/bootstrap.min.css';
import React, { useEffect, useState } from 'react';
import { CloseButton, Col, Container, Image, Row, Spinner  } from 'react-bootstrap';
import * as Icon from 'react-bootstrap-icons';
import Category from './Category';
import Footer from './Footer';
import Header from './Header';
import { useTranslation } from "react-i18next";
import * as RIcon from "react-icons/fa"
import { Link, useLocation, useNavigate } from 'react-router-dom';
import CardRegist from './common/CardRegist';
import { Alert, Card, CardContent, CardHeader, CardMedia, Chip } from '@mui/material';
import ApiFetch from './ApiFetch';
import CommonDialog from './common/CommonDialog';
import LoadingButton from '@mui/lab/LoadingButton';

const Payment = () => {
	async function getPaymentMethods(){
        return await new ApiFetch().get(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/payment/list").then((r)=>r.json().then((json)=>{
            return json
        }))
    }
	async function updatePaymentMethod(id,statusToken){
        return await new ApiFetch().put(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/payment/method",{id:id,statusToken:statusToken}).then((r)=>r.json().then((json)=>{
            return json
        }))
    }
	async function updateDefault(id,flag){
        return await new ApiFetch().put(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/payment/default",{id:id,flag:flag}).then((r)=>r.json().then((json)=>{
            return json
        }))
    }
	async function deleteCard(id){
        return await new ApiFetch().delete(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/payment/card",{id:id}).then((r)=>r.json().then((json)=>{
            return json
        }))
    }
    const {t,i18n} = useTranslation()
    const navigate = useNavigate()
    const location = useLocation()
    const [selected,setSelected] = useState(0)
    const [showRegistConfirm,setShowRegistConfirm] = useState(false)
    const [showDeleteConfirm,setShowDeleteConfirm] = useState(false)
    const [showDefaultConfirm,setShowDefaultConfirm] = useState(false)
    const [loadingPaymentStatus,setLoadingPaymentStatus] = useState(false)
    const [loadingPaymentDefault,setLoadingPaymentDefault] = useState(false)
    const [loading,setLoading] = useState(true)
    const [paymentMethods,setPaymentMethods] = useState([])
    let param = location.search
    useEffect(() => {
        let id = param.substring(param.indexOf("id?=")+5,param.indexOf("&statusToken="))
        let statusToken = param.substring(param.indexOf("&statusToken=")+13)
        if(id.length === 36 && statusToken.length > 0){
            setLoadingPaymentStatus(true)
            updatePaymentMethod(id,statusToken).then(r => {
                if(r.result){
                    if(r.data.status){
                        setTimeout(() => window.location.href = "/manage/payment?status=OK",1000)
                    } else {
                        window.location.href = "/manage/payment?status=NG"    
                    }
                } else {
                    alert(r.errors)
                }
                setLoadingPaymentStatus(false)
            })
        } else {
            getPaymentMethods().then(r => {
                if(r.result){
                    setPaymentMethods(r.data)
                }
                setLoading(false)
            })
        }
    },[])

    return(
    <div className="wrapper" style={{backgroundColor:"#EEEEEE",borderRadius:"10px"}}>
        <header className="App-header"></header>
        <Header />
        <Category />
        <CommonDialog open={showRegistConfirm}
            content={<CardRegist />}
            onClick={() => setShowRegistConfirm(false)} onClose={() => setShowRegistConfirm(false)} />
        <CommonDialog open={showDeleteConfirm}
            onClick={() => {
                setShowDeleteConfirm(false)
                deleteCard(paymentMethods[selected].id).then(r => {
                    if(r.result){
                        getPaymentMethods().then(r => {
                            if(r.result){
                                setPaymentMethods(r.data)
                            }
                        })
                    }
                })
            }} onClose={() => setShowDeleteConfirm(false)}
            title="このカードを削除しますか？" buttonLabel="削除" buttonColor="warning" showCancelbutton={true} />
        <CommonDialog open={showDefaultConfirm}
            onClick={() => {
                setShowDefaultConfirm(false)
            }} onClose={() => setShowDefaultConfirm(false)}
            title="標準に設定しました。" buttonLabel="OK" buttonColor="info" />
        <Container className='w-100'>
            <div style={{backgroundColor:"#FFFFFF"}} className='mb-3 p-3'>
                支援機能はテスト中です。テストカードを登録して参加することができます。<br />
                支援機能に関する登録情報はリセットされることがあります。<br /><br />
                カード番号<br />
                4100 0000 0000 0100<br />
                01/26 CVC:111
            </div>
            {loadingPaymentStatus ? <Container className='text-center m-3'><Spinner animation="border" size="sm" /> 登録状況を確認しています。</Container> : ""}
            {param.indexOf("status=OK") !== -1 ? <Alert className='m-3'>支払方法が登録されました。<CloseButton onClick={() => navigate("/manage/payment")} /></Alert> : ""}
            {param.indexOf("status=NG") !== -1 ? <Alert severity='error' className='m-3'>支払方法の登録に失敗しました。<CloseButton onClick={() => navigate("/manage/payment")} /></Alert> : ""}
            <h4>支払方法</h4>
            <Row className='mb-4 text-center p-3' style={{backgroundColor:"#FFFFFF"}}>
                {loading ? <Col className='text-center m-3'><Spinner animation="border" size="lg" /></Col> : ""}
                {paymentMethods.map((d,i) => {
                    let yy = d.expire.substring(0,2)
                    let mm = d.expire.substring(2)
                    return <Col xs={12} sm={6} md={6} lg={4} xl={3} xxl={4} key={i}
                        style={{maxWidth:240,cursor:"pointer",border:"1px solid #AAAAAA",borderRadius:"5px",backgroundColor:selected === i ? "#EEEEEE" : "#FFFFFF",margin:"10px auto"}}
                        className='p-3 d-flex'
                        onClick={() => {setSelected(i)}}>
                        <div className='mt-2'>
                            {selected === i ? <Icon.CheckCircleFill style={{color:"green"}} /> : <Icon.Circle />}
                        </div>
                        <div style={{marginLeft:"20px"}}>
                            <b>{d.card_no}</b><br />
                            <span style={{fontSize:"12px",color:"#555555"}}>{d.brand} 有効期限：{mm}/{yy}</span>
                        </div>
                        <div>
                            <CloseButton onClick={() => setShowDeleteConfirm(true)} /><br />
                            {d.default_flag === "1" ? <Chip style={{fontSize:"12px"}} className='mt-3' label="標準" /> : ""}
                        </div>
                    </Col>
                })}
                <div className='mt-3'>
                    <Chip onClick={() => setShowRegistConfirm(true)} label={<><Icon.PlusLg />カードを登録</>} /><br /><br />
                    {loadingPaymentDefault ? <LoadingButton loading variant="outlined">選択中のカードを標準の支払い方法にする</LoadingButton> :
                    (paymentMethods.length === 0 ? "" : <Chip color='info' onClick={() => {
                        setLoadingPaymentDefault(true)
                        updateDefault(paymentMethods[selected].id,"1").then(r => {
                            if(r.result){
                                getPaymentMethods().then(r => {
                                    if(r.result){
                                        setPaymentMethods(r.data)
                                    }
                                    setLoading(false)
                                })
                                setShowDefaultConfirm(true)
                            } else {
                                alert(r.errors)
                            }
                            setLoadingPaymentDefault(false)
                        })
                    }} label={<>選択中のカードを標準の支払い方法にする</>} />)}
                </div>
            </Row>
        </Container>
        <Footer />
    </div>
    )
}

export default Payment;
